import { TableColumProps } from "@/components/molecules/Table";
import { fakeI18n } from "@/i18n";
import { Request, RequestSortProperty } from "@/shared/domain";

export const requestTableColumns: TableColumProps<Request, RequestSortProperty>[] = [
    {
        sortableKey: "requestActionId",
        label: fakeI18n.t("Common.Title"),
        width: 20,
    },
    {
        sortableKey: "remark",
        label: fakeI18n.t("Common.Concerns"),
        width: 16,
    },
    {
        sortableKey: "userName",
        label: fakeI18n.t("Requests.Label.AskBy"),
        width: 16,
    },
    {
        sortableKey: "documentsQuantity",
        label: fakeI18n.t("Requests.Label.Attachments"),
        width: 16,
    },
    {
        sortableKey: "updateDatetime",
        label: fakeI18n.t("Common.Date"),
        width: 14,
    },
    {
        sortableKey: "status.id",
        label: fakeI18n.t("Common.Status"),
        width: 14,
    },
];
